import { type RouteObject } from 'react-router';

import { metadataRoute, pushRoute } from '@@components/Page/detailViewRoutes';
import { ErrorPage } from '@@containers/App/ErrorPage';

export const routes: RouteObject[] = [
    {
        index: true,
        lazy: async () => {
            const { EmbedsList } = await import('@@routes/externalContent/embeds/');

            return { Component: EmbedsList };
        },
    },
    {
        path: 'new',
        lazy: async () => {
            const { EmbedsSetupPage } = await import('@@routes/externalContent/embeds');

            return { Component: EmbedsSetupPage };
        },
    },
    {
        path: ':id',
        lazy: async () => {
            const { EmbedsDetailPage } = await import('@@routes/externalContent/embeds');

            return { Component: EmbedsDetailPage };
        },
        children: [
            {
                index: true,
                lazy: async () => {
                    const { default: Content } =
                        await import('@@routes/externalContent/embeds/components/Content');

                    return { Component: Content };
                },
                errorElement: <ErrorPage />,
            },
            metadataRoute,
            pushRoute,
        ],
    },
];
